import { ASSESSMENT_URL } from "../../utils/url-builder";
import { getInstituteKneuraId } from "../../utils/authentication-access";
import BaseService from "../services/base.service";

class QuestionResponseService extends BaseService {
  constructor() {
    super(ASSESSMENT_URL);
    this.route = "questionResponse/";
  }


  update = (
    assessmentResponseId,
    questionId,
    options,
    chosenOptionDescription,
  ) => {
    return new Promise(async (resolve, reject) => {
      try {
        await this.makePostRequest(
          this.route + "update",
          {
            assessmentResponseId: assessmentResponseId,
            questionId: questionId,
            chosenOptionIds: options,
            chosenOptionDescription: chosenOptionDescription,
          },
          false,
        );
        return resolve();
      } catch (error) {
        reject(error);
      }
    });
  };

  mark = (assessmentResponseId, questionId, isMarked) => {
    return new Promise(async (resolve, reject) => {
      try {
        await this.makePostRequest(
          this.route + "mark",
          {
            assessmentResponseId: assessmentResponseId,
            questionId: questionId,
            isMarked: isMarked,
          },
          false,
        );
        return resolve();
      } catch (error) {
        reject(error);
      }
    });
  };

  questionResponse = (assessmentResponseId, questionId) => {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await this.makeGetRequest(this.route + "read", {
          assessmentResponseId,
          questionId,
        });
        return resolve(res);
      } catch (error) {
        reject(error);
      }
    });
  };

  // Upload File

  uploadAnswerFile = (assessmentResponseId, questionId, file) =>
    new Promise(async (resolve, reject) => {
      console.log("Files ", file);
      try {
        await this.uploadMultipleFiles(
          this.route + "insertFiles",
          {
            assessmentResponseId,
            questionId,
            instituteId: getInstituteKneuraId(),
          },
          "files",
          file,
        );
        return resolve();
      } catch (err) {
        reject(err);
      }
    });

  // Remove File
  removeAnswerFile = (assessmentResponseId, questionId, fileIds) =>
    new Promise(async (resolve, reject) => {
      try {
        await this.makePostRequest(this.route + "removeFiles", {
          assessmentResponseId,
          questionId,
          fileIds,
        });
        return resolve();
      } catch (err) {
        reject(err);
      }
    });
}

const questionResponseService = new QuestionResponseService();
export default questionResponseService;
